export enum OrderAheadMode {
  Disabled = 'Disabled',
  Table = 'Table',
  Tent = 'Tent',
}
